import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=388dd8f7&scoped=true&"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgottenPassword.vue?vue&type=style&index=0&id=388dd8f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388dd8f7",
  null
  
)

export default component.exports